import React, { memo } from "react";

type Props = {
    children: React.ReactNode,
    className?: string,
};

const VideoCatalogItemContainer: React.FC<Props> = ({ children, className = "" }) => (
    <div className={className}>
        {children}
    </div>
);

export default memo(VideoCatalogItemContainer);